import { useAuthStore } from '@/store/auth';

export function useCurrentAdmin() {
  return useAuthStore((s) => s.user);
}

export function useIsAuthenticated() {
  return useAuthStore((s) => Boolean(s.accessToken && s.user));
}
